module.exports = __webpack_public_path__ + "static/media/FoodAT.afdbb028.svg";